<template lang="pug">
.v-field-promocode.field-promocode(:class="computedClass")
	label.field-label(v-if="field.label && field.mode !== 'no-label'" :for="uniqueId")
		| {{field.label}}
		span.field-text__star(v-if="field.required") *
	input.field-input(:type="computedType"
		:inputmode="field.inputmode"
		:disabled="field.disabled"
		:placeholder="field.placeholder"
		v-model="localValue"
		@input="handleInput"
		:id="uniqueId")
	transition(name="fade")
		.field-promocode__note(v-if="field.note") {{field.note}}
	transition(name="fade")
		template(v-if="field.promocode")
			.field-promocode__action
				button.field-promocode__action-btn(
					v-if="field.promocode.addButton"
					:disabled="!localValue"
					@click="promocodeAdd(field?.promocode?.addButton?.action)")
					| {{field?.promocode?.addButton?.text || 'Применить'}}
	template(v-if="field?.promocode.items?.length")
		transition(name="fade")
			transition-group.field-promocode__list(tag="div" name="content-fade")
				template(v-for="({text, value}, index) in field.promocode.items" :key="index" )
					.field-promocode__item
						.field-promocode__text(v-if="text")  {{text || 'промокод'}}
						button.btn.btn--primary.btn--sm.field-promocode__button(@click="removePromocode(field?.promocode?.removeButton?.action, value)") {{ field?.promocode?.removeButton?.text || 'Удалить' }}

</template>

<script>
	import uniqueId from '../scripts/helpers/uniqueId.js';

	export default {
		props: {
			field: {
				type: Object,
				default: null,
				required: true
			},

			modelValue: {
				type: [String, Number],
				default: null
			}
		},

		emits: [
			'update:model-value',
			'removePromocode',
			'addPromocode'
		],

		data() {
			return {
				localValue: null,
				savedValue: null,
				unmaskedValue: null,
				isModifiedType: false,
				fullUnmaskedValueLength: 0,
				uniqueId: uniqueId('field-text_')
			};
		},

		computed: {
			computedType() {
				if (!this.field.type || this.field.type == 'number') {
					return 'text';
				}
				return this.field.type;
			},

			computedClass() {
				return {
					['field-promocode--' + this.field.size] : this.field.size,
					['field-promocode--change'] : this.field.change,
					[this.field.className] : this.field.className
				};
			},

		},

		watch: {
			modelValue: {
				immediate: true,
				handler() {
					this.localValue = this.modelValue;

				}
			}
		},

		methods: {

			handleInput() {
				this.$emit('update:model-value', this.localValue);
			},

			removePromocode(action = 'remove_promocode', value) {
				this.$emit('removePromocode', {action, value });
			},

			promocodeAdd(action = 'add_promocode') {
				this.$emit('addPromocode', {action, value: this.localValue });
			},



		}
	};
</script>
